import { useState } from 'react';

import { Box } from '@mui/material';
import { SketchPicker as ColorPicker, ColorResult } from 'react-color';

export type ColorSelectorProps = {
    color: string;
    onChange: (color: ColorResult) => void;
}

function ColorSelector(props: ColorSelectorProps) {
    const [showPrimaryColorSelector, setShowPrimaryColorSelector] = useState(false);

    return (
        <>
            <Box sx={{padding: '5px', borderRadius: '1px', boxShadow: '0 0 0 1px rgba(0,0,0,.1)', display: 'inline-block'}} bgcolor={'#fff'} onClick={() => setShowPrimaryColorSelector(!showPrimaryColorSelector)}>
                <Box sx={{width: '100px', height: '40px', borderRadius: '2px'}} bgcolor={props.color}></Box>
            </Box>
            { showPrimaryColorSelector ?
                <Box style={{position: 'absolute', zIndex: 2}}>
                <Box sx={{position: 'fixed', top:'0px', right:'0px', bottom: '0px', left: '0px'}} onClick={() => setShowPrimaryColorSelector(!showPrimaryColorSelector)}></Box>
                <ColorPicker color={props.color} onChange={(color) => props.onChange(color)}></ColorPicker>
                </Box>
            : <></>
            }
        </>
    );
}

export default ColorSelector;